<template>
  <div class="navbar" :class="{ 'scrolled': isScrolled }">
    <div class="navbar-top">
      <div class="page-container">
        <div class="left-section">
          <Logo to="/" />
        </div>
        <div class="right-section">
          <div class="action-buttons">
            <el-dropdown @command="handleLanguageChange" trigger="click">
              <span class="language-switcher globe-switcher">
                <el-icon><Globe /></el-icon>
                {{ $t('navbar.languageNames.' + currentLocale) }}
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="zh">{{ $t('navbar.languageNames.zh') }}</el-dropdown-item>
                  <el-dropdown-item command="en">{{ $t('navbar.languageNames.en') }}</el-dropdown-item>
                  <el-dropdown-item command="ja">{{ $t('navbar.languageNames.ja') }}</el-dropdown-item>
                  <el-dropdown-item command="ko">{{ $t('navbar.languageNames.ko') }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <el-input
                class="search-input"
                :placeholder="$t('navbar.searchPlaceholder')"
                v-model="searchKeyword"
                @keyup.enter="handleSearch"
            >
              <template #prefix>
                <el-icon><Search /></el-icon>
              </template>
            </el-input>
<!--            <el-button type="primary" size="small" @click="handleLoginClick">-->
<!--              {{ $t('navbar.login') }}-->
<!--            </el-button>-->
          </div>
        </div>
      </div>
    </div>

    <div class="navbar-main">
      <div class="page-container main-container">
        <el-menu
          :default-active="activeIndex"
          class="main-menu"
          mode="horizontal"
          background-color="#163C7D"
          text-color="#fff"
          active-text-color="#fff"
          @select="handleSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/">{{ $t('navbar.home') }}</el-menu-item>

          <el-sub-menu index="/about">
            <template #title>{{ $t('navbar.about') }}</template>
            <el-menu-item index="/about">{{ $t('navbar.aboutCompany') }}</el-menu-item>
            <el-menu-item index="/about/history">{{ $t('navbar.aboutHistory') }}</el-menu-item>
<!--            <el-menu-item index="/about/team">{{ $t('navbar.aboutTeam') }}</el-menu-item>-->
<!--            <el-menu-item index="/about/organization">{{ $t('navbar.aboutOrg') }}</el-menu-item>-->
          </el-sub-menu>

          <el-sub-menu index="/news">
            <template #title>{{ $t('navbar.news') }}</template>
            <el-menu-item index="/news">{{ $t('navbar.newsInfo') }}</el-menu-item>
          </el-sub-menu>

          <el-sub-menu index="/boxs">
            <template #title>{{ $t('navbar.boxs') }}</template>
            <el-menu-item index="/boxs">{{ $t('navbar.boxsOverview') }}</el-menu-item>
<!--            <el-menu-item index="/boxs/services">{{ $t('navbar.boxsServices') }}</el-menu-item>-->
<!--            <el-menu-item index="/boxs/projects">{{ $t('navbar.boxsProjects') }}</el-menu-item>-->
          </el-sub-menu>

          <el-menu-item index="/recruits">{{ $t('navbar.recruits') }}</el-menu-item>
          <el-menu-item index="/touch">{{ $t('navbar.touch') }}</el-menu-item>
        </el-menu>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div class="mobile-navbar">
      <div class="mobile-navbar-top">
        <div class="mobile-logo">
          <Logo to="/" />
        </div>
        <div class="mobile-actions">
          <el-icon class="icon-btn" @click="showSearch = !showSearch"><Search /></el-icon>
          <el-icon class="icon-btn" @click="toggleMobileMenu">
            <component :is="mobileMenuOpen ? Close : Menu" />
          </el-icon>
        </div>
      </div>

      <div class="mobile-search" v-if="showSearch">
        <el-input
            :placeholder="$t('navbar.searchPlaceholder')"
            v-model="searchKeyword"
            @keyup.enter="handleSearch"
        >
          <template #prefix>
            <el-icon><Search /></el-icon>
          </template>
        </el-input>
      </div>

      <div class="mobile-menu" v-if="mobileMenuOpen">
        <el-collapse accordion>
          <el-collapse-item :title="$t('navbar.home')" name="home">
            <router-link to="/" @click="toggleMobileMenu">{{ $t('navbar.home') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('navbar.about')" name="about">
            <router-link to="/about" @click="toggleMobileMenu">{{ $t('navbar.aboutCompany') }}</router-link>
            <router-link to="/about/history" @click="toggleMobileMenu">{{ $t('navbar.aboutHistory') }}</router-link>
            <router-link to="/about/team" @click="toggleMobileMenu">{{ $t('navbar.aboutTeam') }}</router-link>
            <router-link to="/about/organization" @click="toggleMobileMenu">{{ $t('navbar.aboutOrg') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('navbar.news')" name="news">
            <router-link to="/news" @click="toggleMobileMenu">{{ $t('navbar.newsInfo') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('navbar.boxs')" name="business">
            <router-link to="/boxs" @click="toggleMobileMenu">{{ $t('navbar.boxsOverview') }}</router-link>
            <router-link to="/boxs/services" @click="toggleMobileMenu">{{ $t('navbar.boxsServices') }}</router-link>
            <router-link to="/boxs/projects" @click="toggleMobileMenu">{{ $t('navbar.boxsProjects') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('navbar.recruits')" name="jobs">
            <router-link to="/recruits" @click="toggleMobileMenu">{{ $t('navbar.recruits') }}</router-link>
          </el-collapse-item>
          <el-collapse-item :title="$t('navbar.touch')" name="contact">
            <router-link to="/touch" @click="toggleMobileMenu">{{ $t('navbar.touch') }}</router-link>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { Search, Menu, Close, Globe } from '@element-plus/icons-vue'
import Logo from './Logo.vue'

export default {
  name: 'Navbar',
  components: {
    Logo,
    Search,
    Menu,
    Close,
    Globe
  },
  setup() {
    const { t, locale } = useI18n()
    const route = useRoute()
    const router = useRouter()
    const isScrolled = ref(false)
    const mobileMenuOpen = ref(false)
    const showSearch = ref(false)
    const searchKeyword = ref('')

    const activeIndex = computed(() => route.path)
    const currentLocale = computed(() => locale.value)

    const handleScroll = () => {
      if (typeof window !== 'undefined') {
        isScrolled.value = window.scrollY > 50
      }
    }

    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
      if (mobileMenuOpen.value) showSearch.value = false
    }

    const handleSearch = () => {
      if (searchKeyword.value && searchKeyword.value.trim()) {
        router.push({
          path: '/search',
          query: { keyword: searchKeyword.value }
        })
        searchKeyword.value = ''
        showSearch.value = false
      }
    }

    const handleSelect = (index) => {
      if (index) router.push(index)
    }

    const handleLoginClick = () => {
      if (typeof window !== 'undefined') {
        window.location.href = 'http://localhost:8080'
      }
    }

    const handleLanguageChange = (lang) => {
      locale.value = lang
    }

    watch(() => route.path, () => {
      mobileMenuOpen.value = false
      showSearch.value = false
    })

    onMounted(() => {
      if (typeof window !== 'undefined') {
        window.addEventListener('scroll', handleScroll)
        handleScroll()
      }
    })

    onUnmounted(() => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll)
      }
    })

    return {
      t,
      activeIndex,
      isScrolled,
      mobileMenuOpen,
      showSearch,
      searchKeyword,
      toggleMobileMenu,
      handleSearch,
      handleSelect,
      handleLoginClick,
      handleLanguageChange,
      currentLocale,
      Search,
      Menu,
      Close,
      Globe
    }
  }
}
</script>


<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;

  .navbar-top {
    background-color: #fff;
    padding: 15px 0;

    .page-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left-section {
      display: flex;
      align-items: center;
    }

    .right-section {
      display: flex;
      align-items: center;

      .action-buttons {
        display: flex;
        align-items: center;
        gap: 15px;

        .language-switcher {
          color: #333;
          font-weight: 500;
          text-decoration: none;
        }

        .globe-switcher {
          font-size: 20px;
          cursor: pointer;
          //transition: transform 1s linear;
          display: flex;
          align-items: center;

          //&:hover {
          //  transform: rotate(360deg);
          //}

          .el-icon {
            color: #409eff;
            font-size: 24px;
          }
        }

        .search-input {
          width: 180px;
        }
      }
    }
  }

  .navbar-main {
    background-color: #163C7D;

    .main-container {
      display: flex;
      justify-content: space-between;
    }

    .main-menu {
      border-bottom: none;
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    :deep(.el-menu-item) {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;

      &.is-active {
        background-color: #072a68 !important;
        border-bottom: 3px solid #fff;
      }

      &:hover {
        background-color: #072a68 !important;
      }
    }

    :deep(.el-sub-menu__title) {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;

      &:hover {
        background-color: #072a68 !important;
      }
    }

    :deep(.el-sub-menu__icon-arrow) {
      color: #fff;
    }
  }

  .mobile-navbar {
    display: none;
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .mobile-navbar-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
    }

    .mobile-actions {
      display: flex;
      align-items: center;
      gap: 20px;

      .icon-btn {
        font-size: 24px;
        cursor: pointer;
        color: #333;
      }
    }

    .mobile-search {
      padding: 0 15px 15px;
    }

    .mobile-menu {
      background-color: #f5f5f5;
    }

    :deep(.el-collapse-item__header) {
      padding: 0 15px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }

    :deep(.el-collapse-item__content) {
      padding: 0;

      a {
        display: block;
        padding: 12px 30px;
        color: #666;
        text-decoration: none;
        border-bottom: 1px solid #eee;

        &:hover {
          color: var(--primary-color);
          background-color: #f0f0f0;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .navbar {
    .navbar-top,
    .navbar-main {
      display: none;
    }

    .mobile-navbar {
      display: block;
    }
  }
}
</style>
